// extracted by mini-css-extract-plugin
export default {"wrapper":"Collapser_wrapper__ZF8qI","inner":"Collapser_inner__byj-v","open":"Collapser_open__lqBLa"};